const schedulerSwedish = {
  header: {
    title: "LinkedIn Planerare",
    description: "Ställ in vilka dagar och tider dina LinkedIn-inlägg ska skickas."
  },
  limits: {
    scheduled: "Schemalagda inlägg: {count}",
    weekly: "Veckogräns: {limit}",
    remaining: "Återstående: {count}"
  },
  limitWarning: {
    used: "Du har schemalagt alla dina {limit} veckovisa inlägg. Uppgradera ditt abonnemang för att få fler.",
    upgrade: "Uppgradera abonnemang",
    low: "Du har {remaining} inlägg kvar för schemaläggning denna vecka."
  },
  loading: "Laddar dina inställningar...",
  botDelivery: {
    title: "Bot Leveransschema",
    description: "Ställ in när du vill ta emot de veckovisa inläggen från botten",
    day: "Leveransdag:",
    time: "Tid:",
    info: "Det första meddelandet kommer {day} kl. {time}. Efterföljande meddelanden kommer när du har accepterat ett inlägg."
  },
  postSchedule: {
    title: "LinkedIn Inläggsschema",
    description: "Välj vilka dagar och tider dina LinkedIn-inlägg ska publiceras",
    days: {
      monday: "Måndag",
      tuesday: "Tisdag",
      wednesday: "Onsdag",
      thursday: "Torsdag",
      friday: "Fredag",
      saturday: "Lördag",
      sunday: "Söndag"
    },
    addTime: "Lägg till tid",
    onePosts: "1 inlägg",
    multiplePosts: "{count} inlägg"
  },
  summary: {
    title: "Sammanfattning:",
    description: "Dina LinkedIn-inlägg kommer att publiceras vid följande tider:",
    totalPosts: "Totalt schemalagda inlägg: {count} av {limit}"
  },
  timeModal: {
    title: "Välj en tid för {day}",
    label: "Välj tid:",
    info: "Inlägg vid denna tid kommer att automatiskt delas på LinkedIn.",
    cancel: "Avbryt",
    add: "Lägg till tid"
  },
  save: {
    button: "Spara inställningar",
    success: "Dina schemaläggningsinställningar har sparats!",
    error: "Ett fel uppstod när dina inställningar skulle sparas. Försök igen senare."
  },
  timezone: {
    label: "Tidszon:",
    info: "Alla tider anges i tidszonen: {timezone}"
  },
  customerBanner: "Du redigerar schema för {customerName}"
};

export default schedulerSwedish; 